import { IPublishedNews, IResidentNewsContent } from '../../../models';

export const newsConverter = {
  fromDto: (response: IResidentNewsContent): IPublishedNews => {
    return {
      id: response.id,
      title: response.title,
      text: response.text,
      href: response.href,
      linkText: response.linkText,
      titleImageId: response.titleImageId,
      publishedAt: response.publishedAt,
    };
  },
};
